import * as React from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation, withTranslation, WithTranslation } from 'react-i18next'
import { checklistUpdateComponent } from '../../../../redux/actions/checklistEdit'
import FormComponentBuilder, { FormComponentBuilderChildrenProps } from '../FormComponent/FormComponentBuilder'
import { useState } from 'react'

export interface ComponentData {
  id: string
  optional: boolean
  type: {
    type: string
    value: number
  }
  defaultValue: number
  lastValue: number
}

export interface OwnProps {
  componentData: ComponentData
  checklistInstanceId: string
  checkId: string
  collapseHandler?: Function
}

export type Props = OwnProps & WithTranslation

export class AssetHoursComponent extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
    this.manageCollapsable()
  }

  private manageCollapsable() {
    if (
      this.props.componentData.lastValue !== this.props.componentData.defaultValue &&
      this.props.componentData.optional &&
      this.props.collapseHandler
    ) {
      this.props.collapseHandler()
    }
  }

  public render() {
    return (
      <div className="collapse cl-controls-optional cl-controls-optional-1 show">
        <FormComponentBuilder<number> component={this.props.componentData} className="form-group text-left">
          {props => (
            <>
              <label htmlFor={`${this.props.componentData.id}-value`}>
                {this.props.t('checklist.components.assetHours.value')}
              </label>
              <_Input
                {...props}
                checklistInstanceId={this.props.checklistInstanceId}
                componentId={this.props.componentData.id}
              />
            </>
          )}
        </FormComponentBuilder>
      </div>
    )
  }
}

function _Input(
  props: FormComponentBuilderChildrenProps<number> & { checklistInstanceId: string; componentId: string }
): JSX.Element {
  const [internalValue, setInternalValue] = useState<string>(props.value.toString())
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const onChange = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setInternalValue(event.target.value)
  }, [])

  const onBlur = React.useCallback((event: React.FocusEvent<HTMLInputElement>) => {
    const value = convertNumber(event.target.value)
    setInternalValue(value.toString())
    dispatch(
      checklistUpdateComponent(props.checklistInstanceId, props.componentId, value, false)
    )
    props.onBlur()
  }, [])

  const convertNumber = React.useCallback((value: string) => {
    const num = parseInt(value, 10)
    if (isNaN(num)) {
      return 0
    }
    return num
  }, [])

  return (
    <input
      type="number"
      min="0"
      step="1"
      id={`${props.componentId}-value`}
      className={`form-control ${props.className}`}
      placeholder={t('checklist.components.assetHours.value')}
      onChange={onChange}
      onBlur={onBlur}
      value={internalValue}
      disabled={props.disabled}
    />
  )
}

export default withTranslation()(AssetHoursComponent)
